export const STORAGE_KEY = {
  VIEW_USER_ROADMAP: 'VIEW_USER_ROADMAP',
  VIEW_SETTLEMENT_INFO_TOOLTIP: 'VIEW_SETTLEMENT_INFO_TOOLTIP',
};

export const STORAGE_VALUE = {
  VIEW_ROADMAP: {
    VIEWED: '1',
    NO_VIEWED: '0',
    DEFAULT: '-1',
  },
  VIEW_SETTLEMENT_INFO_TOOLTIP: {
    VIEWED: '1',
    NO_VIEWED: '0',
  },
};
